import { render, staticRenderFns } from "./WebhookModal.vue?vue&type=template&id=22c41f4c&"
import script from "./WebhookModal.vue?vue&type=script&lang=js&"
export * from "./WebhookModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports